import React, { useEffect, useState } from 'react'
import ProgramManagerPartnerGrid from './ProgramManagerPartnerGrid'
import Select from "react-select";
import ProgramManagerProgramGrid from './ProgramManagerProgramGrid';
import api from '../../utils/api';

const ProgramManagerHome = (props) => {

    const [programManagerList, setProgramManagerList] = useState([])

    useEffect(() => {
        const {tempProgramManagerList} = api.getProgramManagerList()
        .then(({data}) => {
            console.log("List", data)
            const options = data
                .filter(item => item.sProgramManager !== "" && item.sProgramManager !== null) 
                .map(item => ({
                    label: item.sProgramManager,  
                    value: item.sProgramManager, 
                }));
                setProgramManagerList(options)
        })
    }, [])


    const onProgramManagerChange = (option) => {
        console.log("opt", option)
        props.setSelectedProgramManager(option)
        if(option){
            props.getProgramManagerData(option)
            props.getProgramDataforManager(option)
        } else {
            props.setPartnerDataProgramManager([])
            props.setProgramDataManager([])
        }
    }
  return (
    <div>
<h3
      className="spled-black-text"
      style={{
        fontSize: "25px",
        marginRight: 10,
        textAlign: 'center',
        // margin: 10
      }}
    >
      Program Manager Dashboard
    </h3>
        <div className="row mt-4 mb-4">
            <div className="col-4 offset-4">
            <div className=''>
              <Select
                  options={programManagerList}
                  onChange={onProgramManagerChange}
                  value={props.selectedProgramManager}
                  placeholder="Select Program Manager"
                  isClearable
              />
        </div>
            </div>
        </div>

        <div className="row">
            <div className="col-6">
            <ProgramManagerPartnerGrid
            resourceDataSelectedPartner={props.resourceDataSelectedPartner}
            selectedPartnerName={props.selectedPartnerName}
            setSelectedPartnerName={props.setSelectedPartnerName}
            getResourceDataForSelectedPartner={props.getResourceDataForSelectedPartner}
            partnerDataProgramManager={props.partnerDataProgramManager} 
            getProgramManagerData={props.getProgramManagerData} 
            setResourceDataSelectedPartner={props.setResourceDataSelectedPartner}
            selectedProgramManager={props.selectedProgramManager}/>

            </div>
            <div className="col-6">
                <ProgramManagerProgramGrid 
                getPartnerDataForSelectedProgram={props.getPartnerDataForSelectedProgram}
                getProgramDataforManager={props.getProgramDataforManager}
                partnerDataForSelectedProgram={props.partnerDataForSelectedProgram}
                programDataManager={props.programDataManager}
                selectedProgramName={props.selectedProgramName}
                setSelectedProgramName={props.setSelectedProgramName}
                selectedProgramManager={props.selectedProgramManager} />
            </div>
        </div>
    </div>
  )
}

export default ProgramManagerHome
